import deepExtend from "deep-extend";

function measurements(state = {}, action) {
  switch (action.type) {
    case "ADD_MEASUREMENT":
      var newState = Object.assign({}, state);
      var addState = {
        [action.eventId]: {
          [action.studentId]: {
            [action.measurementId]: action.measurementValue
          }
        }
      };

      deepExtend(addState, newState);
      return addState;

    case "UPDATE_MEASUREMENT":
      var newState = Object.assign({}, state);
      var addState = {
        [action.eventId]: {
          [action.studentId]: {
            [action.measurementId]: action.measurementValue
          }
        }
      };

      deepExtend(newState, addState);
      return newState;

    default:
      return state;
  }

  return state;
}

export default measurements;



// WEBPACK FOOTER //
// ./reducers/measurements.js